import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import { Select } from 'src/components/UI'
import { CrewMutateFormType } from '../Information'
import { Get } from 'src/apis/api'
import { AxiosResponse } from 'axios'
import { User } from 'src/types'
import { useSearchParams } from 'react-router-dom'

export const AgentInfo = () => {


    const user = useSelector((state) => (state as any).user.user)

    const [params] = useSearchParams()

    const mode = params.get('mode')


    const isAgent = user?.role_key === "agent"
    const isCrewAgent = user?.role_key?.toLowerCase() === "crewAgent"?.toLowerCase()


    const { register, getValues ,formState:{errors} } = useFormContext<CrewMutateFormType>()


    const { t } = useTranslation()

    const { data, isLoading } = useQuery<Array<User>>({
        queryFn: () => Get('admin/crews/agents') as unknown as any,
        queryKey: ['GetAgents'],
        enabled: !isAgent && !isCrewAgent

    })

    console.log({ data })


    if (isAgent || isCrewAgent)

        return <></>

    return (
        <div className='flex flex-col  gap-4 bg-white p-4 rounded-lg border '>
            <span className='font-semibold'>{t('AgentOrVisaUser')} &nbsp;و&nbsp;  {t('Referral')} <span className='text-gray-300 text-sm font-normal mx-1'> &nbsp;({t('Optional')})</span></span>

            <div className=' flex flex-col lg:flex-row gap-4 items-stretch lg:items-center'>

                <div className='lg:w-1/4 '>

                    <Select
                        options={data?.map(i => ({ label: `${i.name ?? '-'} ${i.last_name ?? '-'}`, value: i.id.toString() }))}
                        label={t('AgentOrVisaUser')}
                        unselectedLabel={`-- ${t('Select')} ${t('agent')} -- `}
                        loading={isLoading}
                        {...register('agent_id')}
                    />
                </div>

                {data?.findIndex(i => i.id.toString() == getValues('agent_id')) == -1 && !!getValues('agent_id') &&  mode == 'edit' && <span className='lg:mt-6 text-red font-bold text-sm'>{t('RecentAgentDidNotFound')}</span>}


                <div className='lg:w-1/4 '>

                    <Select
                        options={data?.map(i => ({ label: `${i.name ?? '-'} ${i.last_name ?? '-'}`, value: i.id.toString() }))}
                        label={t('Referral')}
                        unselectedLabel={`-- ${t('Select')} ${t('Referral')} -- `}
                        loading={isLoading}
                        {...register('ref_id')}
                    />
                </div>

                {data?.findIndex(i => i.id.toString() == getValues('ref_id')) == -1 && !!getValues('ref_id') &&  mode == 'edit' && <span className='lg:mt-6 text-red font-bold text-sm'>{t('ReferralDidNotFound')}</span>}
            </div>

        </div>
    )
}
